import { Link } from '~/components/common/Link'
import { Button } from '~/components/common/Button'
import { FC } from 'react'

interface CampaignRedirectProps {
  title?: string
  description?: string
  label?: string
}

const CampaignRedirect: FC<CampaignRedirectProps> = ({
  title = 'Get Access',
  description = 'To use the DataWeave agent with your own input and output data, please sign up for the Flex account',
  label = 'Get Started'
}) => {
  return (
    <div className='px-6 py-3 text-center'>
      <h2 className='text-xl font-semibold mb-4'>{title}</h2>
      <p className='text-gray-700 mb-6'>{description}</p>
      <Link href='/signup'>
        <Button variant='primary'>{label}</Button>
      </Link>
    </div>
  )
}

export default CampaignRedirect
